import { defineAsyncComponent } from 'vue'
export default {
  blog: defineAsyncComponent(() => import("/opt/build/repo/src/layouts/blog.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/build/repo/src/layouts/default.vue").then(m => m.default || m)),
  generic: defineAsyncComponent(() => import("/opt/build/repo/src/layouts/generic.vue").then(m => m.default || m)),
  homepage: defineAsyncComponent(() => import("/opt/build/repo/src/layouts/homepage.vue").then(m => m.default || m)),
  iframe: defineAsyncComponent(() => import("/opt/build/repo/src/layouts/iframe.vue").then(m => m.default || m)),
  page: defineAsyncComponent(() => import("/opt/build/repo/src/layouts/page.vue").then(m => m.default || m)),
  preview: defineAsyncComponent(() => import("/opt/build/repo/src/layouts/preview.vue").then(m => m.default || m))
}